<template>
  <div>
    <Title class="center-title">物资采购记录</Title>
    <div class="panel">
      <div class="label">申请人</div>
      <div class="value1">{{ extra.applicantName || '—' }}</div>
      <div class="label">申请部门</div>
      <div class="value2">{{ extra.departmentName || '—' }}</div>

      <div class="label">申请日期</div>
      <div class="value1">{{ extra.applyDate || '—' }}</div>
      <div class="label">类别</div>
      <div class="value2">{{ categoryLabel }}</div>
    </div>

    <!-- 酒水清单 -->
    <template v-if="category === 'wine'">
      <Title class="sub-title">酒水清单</Title>
      <a-table
        v-if="materialList.length > 0"
        bordered
        :dataSource="materialList"
        :pagination="false"
      >
        <a-table-column title="酒水品名" data-index="name" />
        <a-table-column title="类型" data-index="typeInvName" />
        <a-table-column title="子类型" data-index="typeSubName" />
        <a-table-column title="单位" data-index="unitName" align="center" />
        <a-table-column title="单价(元)" data-index="unitPrice" align="center" />
        <a-table-column title="数量" data-index="quantity" align="center" />
      </a-table>
      <span v-else style="padding: 8px; color: #999">暂无酒水明细</span>
    </template>

    <!-- 礼品清单 -->
    <template v-else-if="category === 'gift'">
      <Title class="sub-title">礼品清单</Title>
      <a-table
        v-if="materialList.length > 0"
        bordered
        :dataSource="materialList"
        :pagination="false"
      >
        <a-table-column title="礼品名" data-index="name" />
        <a-table-column title="类型" data-index="typeInvName" />
        <a-table-column title="子类型" data-index="typeSubName" />
        <a-table-column title="单位" data-index="unitName" align="center" />
        <a-table-column title="单价(元)" data-index="unitPrice" align="center" />
        <a-table-column title="数量" data-index="quantity" align="center" />
      </a-table>
      <span v-else style="padding: 8px; color: #999">暂无礼品明细</span>
    </template>

    <!-- 物料清单 -->
    <template v-else>
      <Title class="sub-title">物料清单</Title>
      <a-table
        v-if="materialList.length > 0"
        bordered
        :dataSource="materialList"
        :pagination="false"
      >
        <a-table-column title="分类" data-index="category" />
        <a-table-column title="商品名称" data-index="name" />
        <a-table-column title="规格型号" data-index="spec" />
        <a-table-column title="颜色" data-index="color" />
        <a-table-column title="单位" data-index="unit" />
        <a-table-column title="单价(元)" data-index="price" />
        <a-table-column title="申领数量" data-index="amount">
          <template slot-scope="text, record">
            {{ text || record.count || 0 }}
          </template>
        </a-table-column>
        <a-table-column title="备注" data-index="remark" />
      </a-table>
      <span v-else style="padding: 8px; color: #999">暂无物料明细</span>
    </template>

    <Padding />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";

export default {
  components: { Title },
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return (this.detail && this.detail.extra) ? this.detail.extra : {};
    },
    materialList() {
      const rawList = this.extra.subList || this.extra.materialsList;
      if (!rawList) return [];

      // 处理字符串和数组两种格式
      if (typeof rawList === 'string') {
        try {
          const parsed = JSON.parse(rawList);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.error('materialList JSON parse error:', e);
          return [];
        }
      }
      return Array.isArray(rawList) ? rawList : [];
    },
    // 获取类别：优先使用 purchaseCategory，否则从列表第一项的 typeInv 推导
    category() {
      return this.extra.purchaseCategory
        || (this.materialList.length > 0 ? this.materialList[0].typeInv : '')
        || '';
    },
    categoryLabel() {
      const map = { wine: '酒水', gift: '礼品', material: '物料' };
      return map[this.category] || this.extra.purchaseCategory || '—';
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .center-title {
  font-size: 24px;
  left: 0;
  text-align: center;
  margin-top: -65px;
  margin-bottom: 30px;
  margin-left: 150px;

  &::before {
    display: none;
  }
}

::v-deep .sub-title {
  font-size: 16px;
  margin-top: 24px;
  margin-bottom: 12px;
  left: 0;

  &::before {
    display: none;
  }
}

.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>
